import React from 'react';
import useAxios from 'axios-hooks';
import ControlButtons from 'components/shared/controls/ControlButtons';
import { LIVE_CORE_COMMANDS } from '../../constants';

// Schema-driven turbines (MQTT bridge) don't have an xlsx "Command" sheet -
// their commands are the coil rows of their TurbineSchemaRegister, editable
// from the admin panel. dbname doubles as both the button label and the
// mqttCommand tag (see ExecuteActionButton's useMqttCommand path).
//
// Vestas (real, live turbines) shows ALL of its commands here, in the Live
// tab's "CONTROLS" section (2026-09-23 request, corrected same day - not the
// Advanced tab, see components/advanced/AdvancedControlButtons.js which
// excludes Vestas entirely to avoid showing the same commands twice). No
// longer behind the shared controls password (2026-10-04 request) - removed
// here AND server-side in userHasActionRight() (Orbital-server/src/utils.js),
// since the server enforced it independently of whatever the frontend sent.
const SchemaControlButtons = ({ windTurbineIdentifier, schemaId }) => {
  const [{ data: coils }] = useAxios({
    url: '/turbineSchemaRegisters',
    params: {
      filter: JSON.stringify({ schemaId, registerType: 'coil' }),
    },
  });

  const isVestas = schemaId === 'vestas';
  const buttons = (coils || [])
    .filter((r) => isVestas || LIVE_CORE_COMMANDS.includes(r.dbname))
    .map((r) => ({ dbname: r.dbname, function: r.dbname }));

  return (
    <ControlButtons
      windTurbineIdentifier={windTurbineIdentifier}
      buttons={buttons}
      useMqttCommand
    />
  );
};

const LiveControlButtons = (props) => {
  const schemaId = props.windTurbine.type && props.windTurbine.type.schemaId;

  if (schemaId) {
    return (
      <SchemaControlButtons
        windTurbineIdentifier={props.windTurbine.identifier}
        schemaId={schemaId}
      />
    );
  }

  return (
    <ControlButtons
      windTurbineIdentifier={props.windTurbine.identifier}
      buttons={props.turbineParams ? props.turbineParams.Command.filter(b => b.dbname && b.permission === 0) : []}
    />
  );
};

LiveControlButtons.propTypes = {};

LiveControlButtons.defaultProps = {};

export default LiveControlButtons;
